exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back {\n  background-image: url(/assets/img/background/bg2.jpg);\n  background-color: darkturquoise;\n  background-size: cover;\n}\n#inspire {\n  background: none;\n}\n.buttonFull {\n  height: 50px;\n  font-size: 20px;\n  border-radius: 5px;\n}\n.playstore-icon {\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
